import React from 'react';
import { useSelector } from 'react-redux';
import { MissionsButton } from './modals/MissionsModal/components/MissionsButton';
import { StoriesButton } from './modals/StoriesModal/components/StoriesButton';
import { DesignButton } from './common/DesignButton';
import { SettingsButton } from './common/SettingsButton';
import { translate } from 'game/translate';
import { Store } from 'game/store/gameStore';

export const GameStats: React.FC<{ className?: string }> = ({ className }) => {
  const { gameStats, labels, buttons } = useSelector((state: any) => state.gameUI);
  
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const handleButtonClick = (buttonKey: string, data?: any) => {
    document.dispatchEvent(new CustomEvent('ui-button-click', {
      detail: { buttonKey, data }
    }));
  };

  return (
    <div id="game-ui-stats" className={`text-white pt-3 d-flex flex-column ${className} h-100 ${buttons.magicWandDisabled ? 'magic-wand-active' : ''}`}>
      
      {gameStats.showDifficulty && (
        <div className="text-center" style={{ paddingTop: '20px', marginBottom: '32px' }}>
          <h5 id="difficulty-text" className="text-light mb-0" style={{
            fontSize: '19px',
            textTransform: 'capitalize',
            fontWeight: 500,
            left: '50%',
            position: 'relative',
            transform: 'translateX(-50%)',
            width: 'fit-content'
          }}>
            {Store.difficultyBalanced ? translate('balanced') : gameStats.difficulty}
          </h5>
        </div>
      )}
      
      <div style={{ paddingTop: '6px' }} className="text-center mb-4">
        <div style={{ marginBottom: '17px' }}>
          <div id="moves-label" style={{ fontSize: '14px', fontWeight: 500 }} className="text-light opacity-75">
            {labels.movesLabel}
          </div>
          <div className="text-light mb-0" id="moves-count" style={{ fontWeight: 500, fontSize: '24px', position: 'relative', bottom: '3px' }}>
            {gameStats.moves}
          </div>
        </div>
        
        <div>
          <div id="time-label" className="text-light opacity-75" style={{ fontSize: '14px', fontWeight: 500 }}>
            {labels.timeLabel}
          </div>
          <div className="text-light mb-0" id="time-display" style={{ fontWeight: 500, fontSize: '24px', position: 'relative', bottom: '3px' }}>
            {typeof gameStats.time === 'number' ? formatTime(gameStats.time) : gameStats.time}
          </div>
        </div>  
      </div>

      <div className="mt-auto d-flex flex-column align-items-center">
        <StoriesButton onClick={() => handleButtonClick('stories')} type="main" disabled={buttons.storiesDisabled} />
        <MissionsButton onClick={() => handleButtonClick('missions')} type="main" />
        {/* <button 
          id="shareButton" 
          onClick={() => handleButtonClick('share')}
          className="circle-btn btn btn-outline-light border-0 rounded-circle position-relative d-flex align-items-center justify-content-center p-0" 
          style={{ width: '55px', height: '55px' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g filter="url(#gamestats-share-filter)">
              <path d="M19.019 7.09096C19.019 7.45759 19.0632 7.81407 19.1464 8.1554L10.9146 12.8484C10.1058 12.0651 9.00422 11.5825 7.79177 11.5825C5.3151 11.5825 3.30078 13.5966 3.30078 16.0735C3.30078 18.5504 5.3151 20.5645 7.79177 20.5645C9.00434 20.5645 10.106 20.0818 10.9148 19.2984L19.1464 23.9911C19.0632 24.3325 19.019 24.689 19.019 25.0557C19.019 27.5324 21.0331 29.5467 23.51 29.5467C25.9869 29.5467 28.001 27.5324 28.001 25.0557C28.001 22.5788 25.9869 20.5645 23.51 20.5645C22.2064 20.5645 21.0309 21.1225 20.2099 22.0123L12.0886 17.3824C12.2149 16.9681 12.283 16.5286 12.283 16.0735C12.283 15.6182 12.2149 15.1786 12.0884 14.7642L20.2098 10.1343C21.0308 11.0241 22.2063 11.5822 23.51 11.5822C25.9869 11.5822 28.001 9.56784 28.001 7.09096C28.001 4.61429 25.9869 2.59998 23.51 2.59998C21.0331 2.59998 19.019 4.61429 19.019 7.09096Z" fill="white"/>
            </g>
            <defs>
              <filter id="gamestats-share-filter" x="3.30078" y="2.59998" width="24.7002" height="28.0104" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="1.06367"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_gamestats_share"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_gamestats_share" result="shape"/>
              </filter>
            </defs>
          </svg>
          {indicators.shareIndicator && (
            <span className="position-absolute translate-middle bg-danger rounded-circle" style={{
              top: '7px',
              left: '88%',
              width: '10px',
              height: '10px'
            }}></span>
          )}
        </button> */}
        
        
        {/* <button 
          id="tutorialButton" 
          onClick={() => handleButtonClick('tutorial')}
          className="circle-btn btn btn-outline-light border-0 rounded-circle position-relative d-flex align-items-center justify-content-center p-0" 
          style={{ width: '55px', height: '55px' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g filter="url(#gamestats-tutorial-filter)">
              <path d="M14.2 26.3197C14.7062 26.4986 15.25 26.1268 15.25 25.5902V7.82711C15.25 7.62943 15.175 7.43175 15.0156 7.30937C14.0969 6.57513 11.9875 5.63379 9.25 5.63379C6.88281 5.63379 4.67031 6.25978 3.34844 6.7681C2.81875 6.9752 2.5 7.50235 2.5 8.07186V25.5008C2.5 26.0609 3.1 26.4515 3.62969 26.2774C5.10625 25.7832 7.44531 25.2137 9.25 25.2137C10.8391 25.2137 12.9531 25.8726 14.2 26.3197ZM17.8 26.3197C19.0469 25.8726 21.1609 25.2137 22.75 25.2137C24.5547 25.2137 26.8938 25.7832 28.3703 26.2774C28.9 26.4562 29.5 26.0609 29.5 25.5008V8.07186C29.5 7.50235 29.1812 6.9752 28.6516 6.77281C27.3297 6.25978 25.1172 5.63379 22.75 5.63379C20.0125 5.63379 17.9031 6.57513 16.9844 7.30937C16.8297 7.43175 16.75 7.62943 16.75 7.82711V25.5902C16.75 26.1268 17.2984 26.4986 17.8 26.3197Z" fill="white"/>
            </g>
            <defs>
              <filter id="gamestats-tutorial-filter" x="2.5" y="5.63379" width="27" height="21.6313" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="0.899982"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_gamestats_tutorial"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_gamestats_tutorial" result="shape"/>
              </filter>
            </defs>
          </svg>
          {indicators.hintsIndicator && indicators.hintsCount > 0 && (
            <span className="position-absolute translate-middle bg-danger rounded-circle d-flex align-items-center justify-content-center text-white fw-bold" style={{
              top: '7px',
              left: '88%',
              width: '16px',
              height: '16px',
              fontSize: '10px'
            }}>
              {indicators.hintsCount}
            </span>
          )}
        </button> */}

        
        <DesignButton type="main" onClick={() => handleButtonClick('design')} />
        <SettingsButton type="main" onClick={() => handleButtonClick('settings')} />
      </div>
    </div>
  );
}; 